export const convertDateStampToMs = (date: string | number) => `${+date * 1000}`;
